module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4T7WTK09DQRCFv+PbBEECpqbB4kiwVKDxTQ0CBQ7Pw/EbMFWAJJjaVrVJPRgCqUBh+QGHTLOXlPb2diu6yYqd7Jw5j13Z7gNHrL8akr5k20Brrj9qVesGuJU0+AOIQy6JxHoDABl+tILpUga2V5pZCbCGB9NBCybavo56CdCgMNl2U9JncedfCklbGZGILaaeALvAEHiQ9Jwdo+0PoCNpZPsK2JF0Ps9gwcRk2h7wLmkqz/Yx0JZ0WiZhFiQeS9CPph4wTvougANJkywJtreBN6AOvAJNoCvpMhdgFA3Ak6SfxCgSqy37TLNJTIAX4Az4Dtq2t4B94C4Aqr5z8XTvgcNwPu1iwOMvLRu9/Y9q+aUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/login-log.png
// module id = eVV6
// module chunks = 36